// Blank switch as the form renders it before the user touches anything.
// SystemIdentification built this literal inline in four separate places, which
// is how the shrink branch below was able to drift away from the others.
export const makeBlankSwitch = () => ({
  UOS: '',
  switchName: '',
  heatingSys: '',
  gasType: '',
  selectedSSR: [],
  application: '',
  switchSize: '',
  ssrRating: '',
  sysId: '',
  deviceName: null,
  zoneId: null,
  deviceMac: null,
  type: null,
  latitude: null,
  longitude: null,
  displaySelectBox: [false, false, false, false, false, false],
});

// Grow by appending blanks, shrink by dropping from the end. Shrinking used to
// rebuild the array from blanks, which wiped the switches the user was keeping.
export const resizeSwitches = (switches, numSwitches, makeBlank) => {
  if (numSwitches < switches.length) {
    return switches.slice(0, numSwitches);
  }

  const resized = [...switches];
  const numToAdd = numSwitches - resized.length;
  for (let i = 0; i < numToAdd; i++) {
    resized.push(makeBlank());
  }
  return resized;
};

